export const ANGULAR_INIT_TIMEOUT_MS = 500;
export const ANSI_ESCAPE_LENGTH = 3;
export const ASCII_SPACE = 32;
export const BASE_36_RADIX = 36;
export const BUN_BUILD_WARNING_SUPPRESSION =
  "wildcard sideEffects are not supported yet";
export const BODY_SLICE_LENGTH = 2000;
export const BYTES_PER_KILOBYTE = 1024;
export const CLI_ARGS_OFFSET = 3;
export const CSS_ERROR_RESOLVE_DELAY_MS = 50;
export const CSS_MAX_CHECK_ATTEMPTS = 10;
export const CSS_MAX_PARSE_TIMEOUT_MS = 500;
export const CSS_SHEET_READY_TIMEOUT_MS = 100;
export const DEFAULT_CHUNK_SIZE = 16_384;
export const DEFAULT_DEBOUNCE_MS = 15;
export const DEFAULT_PORT = 3000;
export const DEV_SERVER_RESTART_DEBOUNCE_MS = 100;
export const DOM_UPDATE_DELAY_MS = 50;
export const FILE_PROTOCOL_PREFIX_LENGTH = 7;
export const FOCUS_ID_PREFIX_LENGTH = 3;
export const FOCUS_IDX_PREFIX_LENGTH = 4;
export const FOCUS_NAME_PREFIX_LENGTH = 5;
export const HMR_UPDATE_TIMEOUT_MS = 2000;
export const HOOK_SIGNATURE_LENGTH = 12;
export const EXCLUDE_LAST_OFFSET = -1;
export const HTTP_STATUS_OK = 200;
export const HTTP_STATUS_BAD_REQUEST = 400;
export const HTTP_STATUS_NOT_FOUND = 404;
export const HOURS_IN_DAY = 24;
export const HOURS_IN_HALF_DAY = 12;
export const MAX_ERROR_LENGTH = 200;
export const MAX_RECONNECT_ATTEMPTS = 60;
export const MILLISECONDS_IN_A_SECOND = 1000;
export const MINUTES_IN_AN_HOUR = 60;
export const SECONDS_IN_A_MINUTE = 60;
export const MILLISECONDS_IN_A_MINUTE =
  MILLISECONDS_IN_A_SECOND * SECONDS_IN_A_MINUTE;
export const MILLISECONDS_IN_A_DAY =
  MILLISECONDS_IN_A_SECOND *
  SECONDS_IN_A_MINUTE *
  MINUTES_IN_AN_HOUR *
  HOURS_IN_DAY;
export const OVERLAY_FADE_DURATION_MS = 150;
export const PING_INTERVAL_MS = 30_000;
export const RAF_BATCH_COUNT = 3;
export const RANDOM_ID_END_INDEX = 11;
export const REBUILD_BATCH_DELAY_MS = 10;
export const REBUILD_RELOAD_DELAY_MS = 200;
export const RECONNECT_INITIAL_DELAY_MS = 500;
export const RECONNECT_POLL_INTERVAL_MS = 300;
export const RAG_CHUNK_ID_PAD_LENGTH = 3;
export const RAG_DOCUMENT_ID_PREVIEW_LENGTH = 32;
export const RAG_DOCUMENT_SLUG_MAX_LENGTH = 48;
export const RAG_MIN_CHUNK_LENGTH_FLOOR = 120;
export const RAG_NATIVE_QUERY_CANDIDATE_LIMIT = 1000;
export const RAG_SEARCH_SCORE_DECIMAL_PLACES = 3;
export const RAG_VECTOR_DIMENSIONS_DEFAULT = 24;
export const REACT_STREAM_SLOT_FAST_DELAY_MS = 5;
export const REACT_STREAM_SLOT_SLOW_DELAY_MS = 20;
export const SIGINT_EXIT_CODE = 130;
export const SIGTERM_EXIT_CODE = 143;
export const SVELTE_CSS_LOAD_TIMEOUT_MS = 500;
export const TIME_PRECISION = 2;
export const TWO_THIRDS = 2 / 3;
export const UNFOUND_INDEX = -1;
export const WEBSOCKET_NORMAL_CLOSURE = 1000;
